// extracted by mini-css-extract-plugin
export default {"burger":"PageNavButton_burger__PKRSD","menu":"PageNavButton_menu__5+wJ8","menuItems":"PageNavButton_menuItems__ZcSpJ"};